import { debounceTime } from 'rxjs/operators';
import { UtilService } from '../../../app/services/util.service';
import { Directive, ElementRef, Input, Renderer2, OnInit, HostListener, OnChanges, OnDestroy, AfterViewInit } from '@angular/core';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'button:not([type=keyboard]),[button]',
    standalone: false
})
export class ButtonDisableDirective implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    @Input() disableButton: any;
    // tslint:disable-next-line:no-input-rename
    @Input() shift: any;
    private oldClass: string;
    subscrption: Subscription;

    constructor(public el: ElementRef, public renderer: Renderer2, private utilService: UtilService) { }
    ngOnInit() {
        const childElement = _.map(this.el.nativeElement.children);
        if (!!childElement && !!childElement.length) {
            this.oldClass = childElement[0].classList[1];
        } else {

        }

    }
    ngAfterViewInit(): void {
        this.subscrption = this.utilService.buttonDisableObservable.pipe().subscribe((response) => {
            let childEl = this.el.nativeElement.children[0];
            if (!!response) {

                this.renderer.addClass(this.el.nativeElement, 'disabled');
                if (!!childEl) {
                    this.renderer.removeClass(childEl, this.oldClass);
                    this.renderer.addClass(childEl, `fa-spinner`);
                    this.renderer.addClass(childEl, `fa-spin`);
                } else {
                    childEl = this.renderer.createElement('i');
                    this.renderer.addClass(childEl, `fa`);
                    this.renderer.addClass(childEl, `fa-spinner`);
                    this.renderer.addClass(childEl, `fa-spin`);
                    this.renderer.insertBefore(this.el.nativeElement, childEl, this.el.nativeElement.firstChild);

                }
            }
            setTimeout(() => {
                if (!response) {

                    this.renderer.removeClass(this.el.nativeElement, 'disabled');
                    if (!!childEl) {
                        this.renderer.removeClass(childEl, `fa-spin`);
                        this.renderer.removeClass(childEl, `fa-spinner`);
                        this.renderer.addClass(childEl, `${this.oldClass}`);
                    }
                    this.renderer.removeClass(this.el.nativeElement, 'disabled');

                }
            }, 1000);


        });
    }
    ngOnChanges() {
    }
    @HostListener('click')
    onClick() {


    }
    ngOnDestroy(): void {

        if (this.subscrption) {
            this.subscrption.unsubscribe();
        }
    }
}
